"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const reactstrap_1 = require("reactstrap");
const components_1 = require("./../../components");
const drawerContent = (React.createElement(reactstrap_1.Nav, { vertical: true },
    React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer active", href: "#" }, "Link 1"),
    React.createElement(reactstrap_1.NavLink, { className: "toggle-drawer", href: "#" }, "Link 2")));
const userMenu = (React.createElement(components_1.UserMenu, { userImage: React.createElement(components_1.UserMenuImage, { imageUrl: "https://s.gravatar.com/avatar/73e74124b7261376a2686fa5d1ecd9bd?s=480&r=pg", userName: "Danilo Barros" }) },
    React.createElement("div", null,
        React.createElement("div", { className: "d-block" },
            React.createElement("strong", null, "Danilo Barros")),
        React.createElement("div", { className: "d-block" }, "danilo@beakyn.com"),
        React.createElement("div", { className: "d-block" },
            React.createElement("a", { className: "dropdown-menu-link", href: "#" }, "Logout")),
        React.createElement("div", { className: "dropdown-divider" }),
        React.createElement("div", { className: "d-block" },
            React.createElement("small", null, "v1.3.1")))));
exports.LayoutExample = () => (React.createElement(components_1.Layout, { breadcrumbs: ['Page Title'], drawerHeaderTitle: "App Name", drawerContent: drawerContent, elementRight: userMenu, loading: true, mainNavTitle: "App Name" },
    React.createElement("div", { className: "page-comp", style: { marginTop: '4rem' } },
        React.createElement("div", { className: "oage-comp-body" },
            React.createElement(components_1.Welcome, { userName: "Danilo Barros" }, "This is the Welcome component."),
            React.createElement(components_1.Container, null,
                React.createElement(components_1.Button, { color: "primary" }, "Button")))),
    React.createElement(components_1.Snackbar, { open: true }, "Message")));
exports.LayoutExample.displayName = 'LayoutExample';



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/LayoutExample.tsx
// module id = 469
// module chunks = 0